export const schemesDiscountSubMenu = [{
  path: '/schemes-discounts/list/:schemeId(\\d+)',
  component: () => import('@/views/schemes-discounts/list.vue'),
  name: 'schemeManagement.schemesDiscount.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Regional Manager', 'Zonal Manager'],
    title: 'schemeManagement.schemesDiscount.title',
    noCache: true,
    icon: 'auction',
    hidden: true
  }
}, {
  path: '/schemes-discounts/edit/:id(\\d+)',
  component: () => import('@/views/schemes-discounts/manage.vue'),
  name: 'schemeManagement.schemesDiscount.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'schemeManagement.schemesDiscount.edit',
    noCache: true,
    activeMenu: '/schemes-discounts/list/:schemeId(\\d+)',
    hidden: true
  }
}, {
  path: '/schemes-discounts/add/:schemeId(\\d+)',
  component: () => import('@/views/schemes-discounts/manage.vue'),
  name: 'schemeManagement.schemesDiscount.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'schemeManagement.schemesDiscount.add',
    noCache: true,
    activeMenu: '/schemes-discounts/list/:schemeId(\\d+)',
    hidden: true
  }
}];